import type { AccordionProps } from "@wbly/ui/components/Accordion";
import { Root, Item, Heading, Content } from "@wbly/ui/components/Accordion";

export type QnaAccordionProps = {
  items?: QnaAccordionItem[];
} & Omit<AccordionProps, "type">;

export type QnaAccordionItem = {
  title: string;
  content: { __html: string };
};

export function Accordion({ items, ...props }: QnaAccordionProps) {
  return (
    <Root type="single" collapsible defaultValue="0" {...props}>
      {items.map((item, index) => (
        <Item value={index.toString()} key={`${index}-${item.title}`}>
          <Heading>{item.title}</Heading>
          <Content>
            <div dangerouslySetInnerHTML={item.content} />
          </Content>
        </Item>
      ))}
    </Root>
  );
}
